import PrimeForm from './PrimeForm/PrimeForm';

export { default as Templates, generateTemplates } from './Templates';
export { default as Form, generateForm } from './PrimeForm';
export { default as Theme, generateTheme } from './Theme';
export { default as Widgets, generateWidgets } from './Widgets';

export default PrimeForm;
